import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Label } from "reactstrap";

import AgencyFilter from "./AgencyFilter";
import ContractTypeFilter from "./ContractTypeFilter";
import {
  FilterDateRange,
  FilterSearchBox,
} from "Components/Common/TableFilters";
const OffCanvasFilter = ({
  show,
  onCloseClick,
  setFilterValue,
  filterValue,
  setPage,
  setSearchValue,
  searchValue,
}: any) => {
  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      id="offcanvasRight"
      toggle={onCloseClick}
    >
      <OffcanvasHeader className="bg-light" toggle={onCloseClick}>
        Contract Filters
      </OffcanvasHeader>
      <form
        action=""
        className="d-flex flex-column justify-content-end h-100"
        onSubmit={(e) => {
          e.preventDefault();
          onCloseClick();
        }}
      >
        <OffcanvasBody>
          <div className="mb-4">
            <FilterSearchBox
              id="contract-offcanvas-search"
              placeholder="Search contracts..."
              value={searchValue}
              onChange={(value: string) => {
                setSearchValue(value);
                setPage(1);
              }}
            />
          </div>
          {/* <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Status
            </Label>
            <select
              className="form-control"
              data-choices
              data-choices-search-false
              name="choices-single-default2"
              id="choices-single-default2"
              onChange={(e: any) => {
                setFilterValue({
                  ...filterValue,
                  status: e.target.value,
                });
                setPage(1);
              }}
              value={filterValue.status}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div> */}
          <div className="mb-4">
            <Label className="form-label text-muted text-uppercase fw-semibold mb-2">
              Contract Category
            </Label>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-all"
                checked={!filterValue?.isLOA && !filterValue?.underLTA}
                onChange={() => {
                  const { isLOA, underLTA, ...rest } = filterValue || {};
                  setFilterValue(rest);
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-all">
                All Contracts
              </Label>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-loa"
                checked={!!filterValue?.isLOA}
                onChange={() => {
                  setFilterValue({
                    ...filterValue,
                    isLOA: true,
                    underLTA: undefined,
                  });
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-loa">
                Letters of Agreement (LOAs)
              </Label>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-lta"
                checked={!!filterValue?.underLTA}
                onChange={() => {
                  setFilterValue({
                    ...filterValue,
                    underLTA: true,
                    isLOA: undefined,
                  });
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-lta">
                Awarded under an LTA
              </Label>
            </div>
          </div>
          <div className="mb-4">
            <Label
              htmlFor="region-field"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Contract Type
            </Label>
            <ContractTypeFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, contractType: value });
                setPage(1);
              }}
              value={filterValue.contractType}
            />
          </div>

          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Agency
            </Label>
            <AgencyFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, agency: value });
                setPage(1);
              }}
              value={filterValue.agency}
            />
          </div>
          <div className="mb-4">
            <FilterDateRange
              id="contract-offcanvas-date-range"
              value={filterValue?.dateRange}
              onChange={(dateRange: any) => {
                setFilterValue({ ...filterValue, dateRange });
                setPage(1);
              }}
            />
          </div>
        </OffcanvasBody>
        <div className="offcanvas-footer border-top p-3 text-center">
          <button
            type="submit"
            className="btn btn-success w-100"
            onClick={onCloseClick}
          >
            Done
          </button>
        </div>
      </form>
    </Offcanvas>
  );
};

export default OffCanvasFilter;
